import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = {
  key: 0,
  "aria-hidden": "true",
  role: "status",
  class: "inline w-4 h-4 mr-3 text-white animate-spin",
  viewBox: "0 0 100 101",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Button',
  props: {
    buttonText: null,
    isDisabled: { type: Boolean },
    uploading: { type: Boolean },
    className: null,
    handleClick: { type: Function }
  },
  setup(__props: any) {

const { buttonText, isDisabled, uploading, handleClick } = __props as {
    buttonText: string;
    isDisabled: boolean;
    uploading: boolean;
    className?: string;
    handleClick: () => void;
};



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex justify-center", __props.className])
  }, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (__props.handleClick && __props.handleClick(...args))),
      disabled: __props.isDisabled,
      type: "button",
      class: "text-white w-fit mb-20 bg-button-bg hover:bg-button-bg-hover focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium text-sm px-5 py-2.5 text-center mr-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 inline-flex justify-center items-center disabled:opacity-50"
    }, [
      (__props.uploading)
        ? (_openBlock(), _createElementBlock("svg", _hoisted_2))
        : _createCommentVNode("", true),
      _createTextVNode(" " + _toDisplayString(__props.buttonText), 1)
    ], 8, _hoisted_1)
  ], 2))
}
}

})